import { Button, Flex } from "antd";
import { useState } from "react";

import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ModalAddLeaveRequest } from "../../components/modal/hrm/ModalAddLeaveRequest";
import { ILeaveRequestQuery } from "../../models/Hrm";
import { useGetMyLeaveRequests } from "../../query/HrmQuery";
import PersonalLeaveRequestTable from "../../components/personal/PersonalLeaveRequestTable";

export const PersonalLeaveRequests = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [filter, setFilter] = useState<ILeaveRequestQuery>({
    page: 1,
    limit: 10,
  });
  const { data, isLoading } = useGetMyLeaveRequests({
    query: filter,
  });

  return (
    <div className="flex-1  p-4 overflow-auto h-full">
      <Flex
        align="center"
        gap="small"
        wrap="wrap"
        className="mb-6 flex justify-between"
      >
        <Button
          type="default"
          size="large"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          className=" bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
        >
          Quay lại
        </Button>
        <Button type="primary" onClick={() => setIsOpen(true)}>
          Thêm mới
        </Button>
      </Flex>
      <div className="flex justify-end mb-4"></div>
      <PersonalLeaveRequestTable
        data={data!}
        filter={filter}
        setFilter={setFilter}
        isLoading={isLoading}
      />
      <ModalAddLeaveRequest
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        query={filter}
      />
    </div>
  );
};
